import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container } from './ui';

const StyledFeaturedStatistics = styled.section`
  ${sectionMargins('15px', '90px')};
`;

const StyledInner = styled.div`
  ${({ alt }) => {
    if (alt) {
      return css`
        background-color: ${brandColours.primary};
        border-radius: 50px;
        padding: 0 30px;

        ${minBreakpointQuery.smedium`
          padding-top: 30px;
          padding-bottom: 30px;
        `}

        ${minBreakpointQuery.large`
          padding-top: 45px;
          padding-bottom: 45px;
        `}
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
`;

const StyledItems = styled.div`
  display: flex;
  justify-content: center;

  ${maxBreakpointQuery.smedium`
    flex-direction: column;
  `}
`;

const StyledItem = styled.article`
  text-align: center;
  padding: 30px;

  ${minBreakpointQuery.smedium`
    width: calc(100% / 3);
  `}

  &:not(:last-child) {
    ${maxBreakpointQuery.smedium`
      border-bottom: solid 1px ${standardColours.lightGrey};
    `}

    ${minBreakpointQuery.smedium`
      border-right: solid 1px ${standardColours.lightGrey}
    `}
  }
`;

const StyledStatistic = styled.span`
  ${fluidFontSize(
    '60px',
    '80px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge
  )};
  font-weight: ${fontWeights.bold};
  line-height: 1;
`;

const StyledText = styled.p`
  ${fontSize(20)};
  white-space: break-spaces;
  line-height: 1.5;
  margin-top: 8px;

  ${minBreakpointQuery.large`
    ${fontSize(22)};
    margin-top: 12px;
  `}
`;

const FeaturedStatistics = ({ items, alt }) => (
  <StyledFeaturedStatistics>
    <Container>
      <StyledInner alt={alt}>
        <StyledContainer>
          <StyledItems>
            {items.map(({ statistic, text }, id) => (
              <StyledItem key={id}>
                <StyledStatistic>{statistic}</StyledStatistic>
                <StyledText>{text}</StyledText>
              </StyledItem>
            ))}
          </StyledItems>
        </StyledContainer>
      </StyledInner>
    </Container>
  </StyledFeaturedStatistics>
);

export default FeaturedStatistics;
